import React from 'react';

import {
  StyledColumn,
  StyledRow,
  LeaseSummaryColumnContent,
  LeaseSummaryColumnTitle,
} from '../common/LeaseStyles';

export default function ServicesUtilities({ leaseDetails }) {
  const services = leaseDetails?.draft_lease_data?.services;
  const utilities = leaseDetails?.draft_lease_data?.utilities;

  // It shouldn't render anything when there are no services nor utilities
  if (!services && !utilities) {
    return null;
  }

  const getValue = (answerType, serviceOrUtility) => {
    switch (answerType) {
      case 'text':
        // If it's a text field, we'll just use the first (and only) answer
        return serviceOrUtility?.answers?.[0]?.answer_value;
      case 'radio':
        // Iterate until find the selected answer
        return serviceOrUtility?.answers?.find((answer) => answer?.selected)?.answer_name;
      default:
        return null;
    }
  };

  const maybeGetAdditionalQuestion = (answerType, serviceOrUtility) => {
    if (answerType !== 'radio') {
      return null;
    }
    const conditionalQuestions = serviceOrUtility?.answers?.find(
      (answer) => answer?.selected
    )?.conditional_questions;

    if (!conditionalQuestions.length) {
      return null;
    }

    // It only has 1 conditional question
    const label = conditionalQuestions[0]?.name;

    if (!label) {
      return null;
    }

    let value;
    switch (conditionalQuestions[0].type) {
      case 'text':
        // If it's a text field, we'll just use the first (and only) answer
        value = conditionalQuestions[0]?.answer_value;
        break;
      case 'radio':
        // Iterate until find the selected answer
        value = conditionalQuestions[0].conditional_answers?.find(
          (answer) => answer?.selected
        )?.name;
        break;
      default:
        break;
    }

    return { label, value };
  };

  const getLabelsAndValuesAndMaybeAdditionalQuestion = (serviceOrUtility) => {
    const label = serviceOrUtility?.question_name;
    const answerType = serviceOrUtility?.answer_type;

    const value = getValue(answerType, serviceOrUtility);

    const maybeAdditionalQuestion = maybeGetAdditionalQuestion(answerType, serviceOrUtility);

    if (maybeAdditionalQuestion !== null) {
      return { label, value, additionalQuestion: maybeAdditionalQuestion };
    }

    return { label, value };
  };

  const servicesList = services?.map((service) =>
    getLabelsAndValuesAndMaybeAdditionalQuestion(service)
  );
  const utilitiesList = utilities?.map((utility) =>
    getLabelsAndValuesAndMaybeAdditionalQuestion(utility)
  );

  const ServiceOrUtilityItem = ({ item }) => (
    <>
      <LeaseSummaryColumnTitle>{item.label}</LeaseSummaryColumnTitle>
      <LeaseSummaryColumnContent>{item.value}</LeaseSummaryColumnContent>
    </>
  );

  const ItemWithAdditionalQuestion = ({ item }) => (
    <StyledRow>
      <StyledColumn md={8}>
        <ServiceOrUtilityItem item={item} />
      </StyledColumn>
      <StyledColumn md={8}>
        <LeaseSummaryColumnTitle>{item.additionalQuestion.label}</LeaseSummaryColumnTitle>
        <LeaseSummaryColumnContent>{item.additionalQuestion.value}</LeaseSummaryColumnContent>
      </StyledColumn>
    </StyledRow>
  );

  const ItemRows = ({ servicesList: itemList }) => {
    return itemList?.map((item) => {
      if (item.additionalQuestion !== undefined) {
        return <ItemWithAdditionalQuestion item={item} />;
      }
      return (
        <StyledRow>
          <StyledColumn md={8}>
            <ServiceOrUtilityItem item={item} />
          </StyledColumn>
        </StyledRow>
      );
    });
  };

  return <ItemRows servicesList={[...servicesList, ...utilitiesList]} />;
}
